import React, { useState, useContext } from 'react'
import { useQuery } from '@apollo/client'
import sortBy from 'lodash/sortBy'
import { Redirect } from 'react-router-dom'
import Typography from '@material-ui/core/Typography'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import CircularProgress from '@material-ui/core/CircularProgress'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import Grid from '@material-ui/core/Grid'
import ProgressInformation from './components/ProgressInformation'
import ProgressGraph from './components/ProgressGraph'
import EngagementQuartileGraph from './components/EngagementQuartileGraph'
import PaceGraph from './components/PaceGraph'
import FilterInput from '../../components/FilterInput'
import { useStyles } from './styles'
import { GET_PROGRESS_DATA, GET_WAVES_LIST } from '../../network/progress/queries'
import { GET_WIDGETS_LIST } from '../../network/auth/queries'
import { LINKS } from '../../constants'
import { MENU_PROPS } from '../../constants/theme'
import { LabContext } from '../../context'

const ProgressPage = () => {
  const classes = useStyles()
  const { selectedLab, selectedAccount } = useContext(LabContext)
  const [filterValue, setFilterValue] = useState({ id: null, name: '' })
  const [progressData, setProgressData] = useState(null)

  const [widgetsList, setWidgetsList] = useState([])
  const { loading: widgetsLoading } = useQuery(GET_WIDGETS_LIST, {
    onCompleted: data => {
      setWidgetsList(data.coordinator.dashboardWidget.list)
    }
  })

  const { loading: waveDataLoading, data: waveData } = useQuery(GET_WAVES_LIST, {
    skip: widgetsLoading || !widgetsList.length || !selectedLab,
    fetchPolicy: 'no-cache',
    variables: {
      labId: selectedLab,
      accountIds: selectedAccount ? [selectedAccount] : undefined
    },
    onCompleted: data => {
      setFilterValue(sortBy(data.coordinator.wave.list, 'name')[0])
    }
  })

  const { loading: progressDataLoading } = useQuery(GET_PROGRESS_DATA, {
    skip: widgetsLoading || !widgetsList.length || !filterValue || !filterValue.id,
    variables: {
      waveId: filterValue && filterValue.id,
      accountIds: selectedAccount ? [selectedAccount] : undefined
    },
    fetchPolicy: 'no-cache',
    onCompleted: data => {
      setProgressData(data)
    }
  })

  const handleFilterChange = value => {
    setFilterValue(value)
  }

  const widget = widgetsList.find(el => el.widget === 'progress')

  return widgetsLoading ||
    !widgetsList.length ||
    !selectedLab ||
    waveDataLoading ||
    progressDataLoading ||
    (!progressData && filterValue && filterValue.id) ? (
    <div className={classes.loader}>
      <CircularProgress color='inherit' />
    </div>
  ) : widget && widget.allowed ? (
    <div className={classes.root}>
      <Grid container spacing={6}>
        <Grid container item xs={12} className={classes.toolbar}>
          <Typography variant='h2' component='div'>
            Progress
          </Typography>
          {filterValue && filterValue.id ? (
            <Select MenuProps={MENU_PROPS} value={filterValue.id} onChange={null} input={<FilterInput />} className={classes.nonDefault}>
              {sortBy(waveData.coordinator.wave.list, 'name').map(item => {
                return (
                  <MenuItem key={item.id} onClick={() => handleFilterChange(item)} value={item.id} className={classes.menuItem}>
                    {item.name}
                  </MenuItem>
                )
              })}
            </Select>
          ) : null}
        </Grid>
        <Grid container item xs={12}>
          {!filterValue || !filterValue.id ? (
            <div className={classes.emptyProgress}>
              <Typography variant='h5' component='div' className={classes.topHeader}>
                Learner Progress
              </Typography>
              <div className={classes.icon}>
                <VisibilityOff />
              </div>
              <Typography variant='h5' component='div' className={classes.header}>
                Learner progress cannot be aggregated for an account that has no wave.
              </Typography>
            </div>
          ) : (
            <>
              <ProgressInformation data={progressData.coordinator.stats} />
              <ProgressGraph
                data={progressData.coordinator.stats}
                filterName={filterValue.name}
                assignedUsersToWaveCount={filterValue.userIds.length}
                type={filterValue.paceGoal ? filterValue.paceGoal.type : null}
              />
              <Grid container alignItems='center' justifyContent='center' item xs={6}>
                <div className={classes.leftBlock}>
                  <EngagementQuartileGraph data={progressData.coordinator.stats} />
                </div>
              </Grid>
              <Grid container alignItems='center' justifyContent='center' item xs={6}>
                <div className={classes.rightBlock}>
                  <PaceGraph
                    data={progressData.coordinator.stats}
                    filterName={filterValue.name}
                    type={filterValue.paceGoal ? filterValue.paceGoal.type : null}
                  />
                </div>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </div>
  ) : (
    <Redirect to={LINKS.DASHBOARD} />
  )
}

export default ProgressPage
